function SidebarLink({ data }) {
    return (
        <div key={data.documentId} className="sidebar-link">
            {data.map((item, index) => (
                <li key={index} className="sidebar-list-item light-blue-text body-text">
                    <a className={item['link']['url'].replace("/","").concat(" bold")} href={item['link']['url']}>
                        {item['link']['label']} </a>
                </li>
            ))}
        </div>
    );
}

export default SidebarLink;
